module.exports = {
	"contractName": "University",
	"abi": [
		{
			"constant": true,
			"inputs": [],
			"name": "time",
			"outputs": [
				{
					"name": "",
					"type": "uint256"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "owner",
			"outputs": [
				{
					"name": "",
					"type": "address"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "universityName",
			"outputs": [
				{
					"name": "",
					"type": "string"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"constant": true,
			"inputs": [],
			"name": "combined",
			"outputs": [
				{
					"name": "",
					"type": "bool"
				}
			],
			"payable": false,
			"stateMutability": "view",
			"type": "function"
		},
		{
			"inputs": [
				{
					"name": "_name",
					"type": "bytes32[6]"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "constructor"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "combine",
			"outputs": [],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		},
		{
			"constant": false,
			"inputs": [
				{
					"name": "_name",
					"type": "string"
				}
			],
			"name": "stringToBytes32",
			"outputs": [
				{
					"name": "name",
					"type": "bytes32"
				}
			],
			"payable": false,
			"stateMutability": "nonpayable",
			"type": "function"
		}
	],
	"bytecode": "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",
	"deployedBytecode": "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",
	"sourceMap": "97:5:24:-;74:28;;-1:-1:-1;;;;;;74:28:24;;;128:3;74:28;106:25;135:63;26:708;135:63;;26:708;135:63;;;;;;;;;;;;;;:::i;:::-;;230:91;8:9:-1;5:2;;;30:1;27;20:12;5:2;230:91:24;;;;;;;;;;;;281:5;:17;;-1:-1:-1;;;;;;281:17:24;289:9;281:17;;;304:12;:4;230:91;304:12;;:::i;:::-;;230:91;26:708;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;26:708:24;;;-1:-1:-1;26:708:24;:::i;:::-;;;:::o;:::-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;:::-;;;;;;;",
	"deployedSourceMap": "26:708:24:-;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;106:25;;8:9:-1;5:2;;;30:1;27;20:12;5:2;106:25:24;;;;;;;;;;;;;;;;;;;;50:20;;8:9:-1;5:2;;;30:1;27;20:12;5:2;50:20:24;;;;;;;;;;;;;;;;;;;;;;;135:63;;8:9:-1;5:2;;;30:1;27;20:12;5:2;135:63:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;8:100:-1;33:3;30:1;27:10;8:100;;;90:11;;;84:18;71:11;;;64:39;52:2;45:10;8:100;;;12:14;135:63:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;74:28;;8:9:-1;5:2;;;30:1;27;20:12;5:2;74:28:24;;;;;;;;;;;;;;;;;;;;;;511:221;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;511:221:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;511:221:24;;-1:-1:-1;511:221:24;;-1:-1:-1;;;;;;;511:221:24;325:182;;8:9:-1;5:2;;;30:1;27;20:12;5:2;-1:-1;325:182:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;-1:-1:-1;325:182:24;;-1:-1:-1;325:182:24;;-1:-1:-1;;;;;;;325:182:24;;;106:25;;;;:::o;50:20::-;;;;;;:::o;135:63::-;;;;;;;;;;;;;;-1:-1:-1;;135:63:24;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;;:::o;74:28::-;;;;;;;;;:::o;511:221::-;628:10;;566:12;;611:5;;628:15;624:46;;;660:3;;-1:-1:-1;653:10:24;;624:46;718:2;711:5;707:14;701:21;693:29;;685:43;;;;;:::o;325:182::-;370:5;;:19;:5;379:10;370:19;362:28;;;;;;427:7;;401:22;417:5;401:15;:22::i;:::-;:33;397:106;;;444:8;:15;;-1:-1:-1;;444:15:24;;;;;397:106;;;491:5;480:16;;-1:-1:-1;;480:16:24;;;397:106;325:182;:::o",
	"source": "pragma solidity ^0.4.18;\n\ncontract University {\n  address public owner;\n  bool public combined = false;\n  uint256 public time = now;\n  string public universityName = \"National Chiao Tung University\";\n  bytes32[6] private name;\n\n  function University(bytes32[6] _name) public {\n    owner = tx.origin;\n    name = _name;\n  }\n\n  function combine(string _name) {\n    require(owner == msg.sender);\n\n    if (stringToBytes32(_name) == name[2]) {\n      combined = true;\n    } else {\n      combined = false;\n    }\n  }\n\n  function stringToBytes32(string memory _name) returns (bytes32 name) {\n    bytes memory tmp = bytes(_name);\n\n    if (tmp.length == 0) {\n      return 0x0;\n    }\n\n    assembly {\n      name := mload(add(_name, 32))\n    }\n  }\n}\n",
	"sourcePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/University.sol",
	"ast": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/University.sol",
		"exportedSymbols": {
			"University": [
				2287
			]
		},
		"id": 2288,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2200,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:24"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2287,
				"linearizedBaseContracts": [
					2287
				],
				"name": "University",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2202,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "50:20:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2201,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "50:7:24",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2205,
						"name": "combined",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "74:28:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2203,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "74:4:24",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 2204,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "97:5:24",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2208,
						"name": "time",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "106:25:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2206,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "106:7:24",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"id": 2207,
							"name": "now",
							"nodeType": "Identifier",
							"overloadedDeclarations": [],
							"referencedDeclaration": 2939,
							"src": "128:3:24",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2211,
						"name": "universityName",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "135:63:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 2209,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "135:6:24",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "4e6174696f6e616c20436869616f2054756e6720556e6976657273697479",
							"id": 2210,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "166:32:24",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
								"typeString": "literal_string \"National Chiao Tung University\""
							},
							"value": "National Chiao Tung University"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2215,
						"name": "name",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "202:23:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_bytes32_$6_storage",
							"typeString": "bytes32[6]"
						},
						"typeName": {
							"baseType": {
								"id": 2212,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "202:7:24",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"id": 2214,
							"length": {
								"argumentTypes": null,
								"hexValue": "36",
								"id": 2213,
								"isConstant": false,
								"isLValue": false,
								"isPure": false,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "210:1:24",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								},
								"value": "6"
							},
							"nodeType": "ArrayTypeName",
							"src": "202:10:24",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
								"typeString": "bytes32[6]"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2231,
							"nodeType": "Block",
							"src": "275:46:24",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2225,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2222,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2202,
											"src": "281:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2223,
												"name": "tx",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2949,
												"src": "289:2:24",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_transaction",
													"typeString": "tx"
												}
											},
											"id": 2224,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "origin",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "289:9:24",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "281:17:24",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2226,
									"nodeType": "ExpressionStatement",
									"src": "281:17:24"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2229,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2227,
											"name": "name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2215,
											"src": "304:4:24",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_storage",
												"typeString": "bytes32[6] storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2228,
											"name": "_name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2219,
											"src": "311:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
												"typeString": "bytes32[6] memory"
											}
										},
										"src": "304:12:24",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_bytes32_$6_storage",
											"typeString": "bytes32[6] storage ref"
										}
									},
									"id": 2230,
									"nodeType": "ExpressionStatement",
									"src": "304:12:24"
								}
							]
						},
						"documentation": null,
						"id": 2232,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "University",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2220,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2219,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2232,
									"src": "250:16:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
										"typeString": "bytes32[6]"
									},
									"typeName": {
										"baseType": {
											"id": 2216,
											"name": "bytes32",
											"nodeType": "ElementaryTypeName",
											"src": "250:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"id": 2218,
										"length": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 2217,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "258:1:24",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "6"
										},
										"nodeType": "ArrayTypeName",
										"src": "250:10:24",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
											"typeString": "bytes32[6]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "249:18:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2221,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "275:0:24"
						},
						"scope": 2287,
						"src": "230:91:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2262,
							"nodeType": "Block",
							"src": "356:151:24",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2241,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2238,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2202,
													"src": "370:5:24",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2239,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "379:3:24",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2240,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "379:10:24",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "370:19:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2237,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "362:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2242,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "362:28:24",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2243,
									"nodeType": "ExpressionStatement",
									"src": "362:28:24"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 2250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 2245,
													"name": "_name",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2234,
													"src": "417:5:24",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 2244,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2286,
												"src": "401:15:24",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2246,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "401:22:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2247,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2215,
												"src": "427:4:24",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_storage",
													"typeString": "bytes32[6] storage ref"
												}
											},
											"id": 2249,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2248,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "432:1:24",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "427:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "401:33:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2260,
										"nodeType": "Block",
										"src": "472:31:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2258,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2256,
														"name": "combined",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2205,
														"src": "480:8:24",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 2257,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "491:5:24",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "480:16:24",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2259,
												"nodeType": "ExpressionStatement",
												"src": "480:16:24"
											}
										]
									},
									"id": 2261,
									"nodeType": "IfStatement",
									"src": "397:106:24",
									"trueBody": {
										"id": 2255,
										"nodeType": "Block",
										"src": "436:30:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2253,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2251,
														"name": "combined",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2205,
														"src": "444:8:24",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 2252,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "455:4:24",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "444:15:24",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2254,
												"nodeType": "ExpressionStatement",
												"src": "444:15:24"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2263,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "combine",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2235,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2234,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2263,
									"src": "342:12:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2233,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "342:6:24",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "341:14:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2236,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "356:0:24"
						},
						"scope": 2287,
						"src": "325:182:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2285,
							"nodeType": "Block",
							"src": "580:152:24",
							"statements": [
								{
									"assignments": [
										2271
									],
									"declarations": [
										{
											"constant": false,
											"id": 2271,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 2286,
											"src": "586:16:24",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 2270,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "586:5:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2275,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2273,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2265,
												"src": "611:5:24",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 2272,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "605:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
												"typeString": "type(bytes storage pointer)"
											},
											"typeName": "bytes"
										},
										"id": 2274,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "605:12:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "586:31:24"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2279,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2276,
												"name": "tmp",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2271,
												"src": "628:3:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 2277,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "628:10:24",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2278,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "642:1:24",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "628:15:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2283,
									"nodeType": "IfStatement",
									"src": "624:46:24",
									"trueBody": {
										"id": 2282,
										"nodeType": "Block",
										"src": "645:25:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 2280,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "660:3:24",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"functionReturnParameters": 2269,
												"id": 2281,
												"nodeType": "Return",
												"src": "653:10:24"
											}
										]
									}
								},
								{
									"externalReferences": [
										{
											"name": {
												"declaration": 2268,
												"isOffset": false,
												"isSlot": false,
												"src": "693:4:24",
												"valueSize": 1
											}
										},
										{
											"_name": {
												"declaration": 2265,
												"isOffset": false,
												"isSlot": false,
												"src": "711:5:24",
												"valueSize": 1
											}
										}
									],
									"id": 2284,
									"nodeType": "InlineAssembly",
									"operations": "{\n    name := mload(add(_name, 32))\n}",
									"src": "676:56:24"
								}
							]
						},
						"documentation": null,
						"id": 2286,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "stringToBytes32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2266,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2265,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2286,
									"src": "536:19:24",
									"stateVariable": false,
									"storageLocation": "memory",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2264,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "536:6:24",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "535:21:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2269,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2268,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 2286,
									"src": "566:12:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 2267,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "566:7:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "565:14:24"
						},
						"scope": 2287,
						"src": "511:221:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2288,
				"src": "26:708:24"
			}
		],
		"src": "0:735:24"
	},
	"legacyAST": {
		"absolutePath": "/Users/billhsu/Desktop/work/github/cypherpunks-ctf/contracts/levels/University.sol",
		"exportedSymbols": {
			"University": [
				2287
			]
		},
		"id": 2288,
		"nodeType": "SourceUnit",
		"nodes": [
			{
				"id": 2200,
				"literals": [
					"solidity",
					"^",
					"0.4",
					".18"
				],
				"nodeType": "PragmaDirective",
				"src": "0:24:24"
			},
			{
				"baseContracts": [],
				"contractDependencies": [],
				"contractKind": "contract",
				"documentation": null,
				"fullyImplemented": true,
				"id": 2287,
				"linearizedBaseContracts": [
					2287
				],
				"name": "University",
				"nodeType": "ContractDefinition",
				"nodes": [
					{
						"constant": false,
						"id": 2202,
						"name": "owner",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "50:20:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_address",
							"typeString": "address"
						},
						"typeName": {
							"id": 2201,
							"name": "address",
							"nodeType": "ElementaryTypeName",
							"src": "50:7:24",
							"typeDescriptions": {
								"typeIdentifier": "t_address",
								"typeString": "address"
							}
						},
						"value": null,
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2205,
						"name": "combined",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "74:28:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_bool",
							"typeString": "bool"
						},
						"typeName": {
							"id": 2203,
							"name": "bool",
							"nodeType": "ElementaryTypeName",
							"src": "74:4:24",
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "66616c7365",
							"id": 2204,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "bool",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "97:5:24",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_bool",
								"typeString": "bool"
							},
							"value": "false"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2208,
						"name": "time",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "106:25:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_uint256",
							"typeString": "uint256"
						},
						"typeName": {
							"id": 2206,
							"name": "uint256",
							"nodeType": "ElementaryTypeName",
							"src": "106:7:24",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"value": {
							"argumentTypes": null,
							"id": 2207,
							"name": "now",
							"nodeType": "Identifier",
							"overloadedDeclarations": [],
							"referencedDeclaration": 2939,
							"src": "128:3:24",
							"typeDescriptions": {
								"typeIdentifier": "t_uint256",
								"typeString": "uint256"
							}
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2211,
						"name": "universityName",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "135:63:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_string_storage",
							"typeString": "string"
						},
						"typeName": {
							"id": 2209,
							"name": "string",
							"nodeType": "ElementaryTypeName",
							"src": "135:6:24",
							"typeDescriptions": {
								"typeIdentifier": "t_string_storage_ptr",
								"typeString": "string"
							}
						},
						"value": {
							"argumentTypes": null,
							"hexValue": "4e6174696f6e616c20436869616f2054756e6720556e6976657273697479",
							"id": 2210,
							"isConstant": false,
							"isLValue": false,
							"isPure": true,
							"kind": "string",
							"lValueRequested": false,
							"nodeType": "Literal",
							"src": "166:32:24",
							"subdenomination": null,
							"typeDescriptions": {
								"typeIdentifier": "t_stringliteral_fdba49c1e437ac80a7c615187b0fd0183e47bea6b9863cc282b9640b9845a224",
								"typeString": "literal_string \"National Chiao Tung University\""
							},
							"value": "National Chiao Tung University"
						},
						"visibility": "public"
					},
					{
						"constant": false,
						"id": 2215,
						"name": "name",
						"nodeType": "VariableDeclaration",
						"scope": 2287,
						"src": "202:23:24",
						"stateVariable": true,
						"storageLocation": "default",
						"typeDescriptions": {
							"typeIdentifier": "t_array$_t_bytes32_$6_storage",
							"typeString": "bytes32[6]"
						},
						"typeName": {
							"baseType": {
								"id": 2212,
								"name": "bytes32",
								"nodeType": "ElementaryTypeName",
								"src": "202:7:24",
								"typeDescriptions": {
									"typeIdentifier": "t_bytes32",
									"typeString": "bytes32"
								}
							},
							"id": 2214,
							"length": {
								"argumentTypes": null,
								"hexValue": "36",
								"id": 2213,
								"isConstant": false,
								"isLValue": false,
								"isPure": false,
								"kind": "number",
								"lValueRequested": false,
								"nodeType": "Literal",
								"src": "210:1:24",
								"subdenomination": null,
								"typeDescriptions": {
									"typeIdentifier": null,
									"typeString": null
								},
								"value": "6"
							},
							"nodeType": "ArrayTypeName",
							"src": "202:10:24",
							"typeDescriptions": {
								"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
								"typeString": "bytes32[6]"
							}
						},
						"value": null,
						"visibility": "private"
					},
					{
						"body": {
							"id": 2231,
							"nodeType": "Block",
							"src": "275:46:24",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"id": 2225,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2222,
											"name": "owner",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2202,
											"src": "281:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2223,
												"name": "tx",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2949,
												"src": "289:2:24",
												"typeDescriptions": {
													"typeIdentifier": "t_magic_transaction",
													"typeString": "tx"
												}
											},
											"id": 2224,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "origin",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "289:9:24",
											"typeDescriptions": {
												"typeIdentifier": "t_address",
												"typeString": "address"
											}
										},
										"src": "281:17:24",
										"typeDescriptions": {
											"typeIdentifier": "t_address",
											"typeString": "address"
										}
									},
									"id": 2226,
									"nodeType": "ExpressionStatement",
									"src": "281:17:24"
								},
								{
									"expression": {
										"argumentTypes": null,
										"id": 2229,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftHandSide": {
											"argumentTypes": null,
											"id": 2227,
											"name": "name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2215,
											"src": "304:4:24",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_storage",
												"typeString": "bytes32[6] storage ref"
											}
										},
										"nodeType": "Assignment",
										"operator": "=",
										"rightHandSide": {
											"argumentTypes": null,
											"id": 2228,
											"name": "_name",
											"nodeType": "Identifier",
											"overloadedDeclarations": [],
											"referencedDeclaration": 2219,
											"src": "311:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
												"typeString": "bytes32[6] memory"
											}
										},
										"src": "304:12:24",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_bytes32_$6_storage",
											"typeString": "bytes32[6] storage ref"
										}
									},
									"id": 2230,
									"nodeType": "ExpressionStatement",
									"src": "304:12:24"
								}
							]
						},
						"documentation": null,
						"id": 2232,
						"implemented": true,
						"isConstructor": true,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "University",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2220,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2219,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2232,
									"src": "250:16:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_array$_t_bytes32_$6_memory_ptr",
										"typeString": "bytes32[6]"
									},
									"typeName": {
										"baseType": {
											"id": 2216,
											"name": "bytes32",
											"nodeType": "ElementaryTypeName",
											"src": "250:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"id": 2218,
										"length": {
											"argumentTypes": null,
											"hexValue": "36",
											"id": 2217,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "258:1:24",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": null,
												"typeString": null
											},
											"value": "6"
										},
										"nodeType": "ArrayTypeName",
										"src": "250:10:24",
										"typeDescriptions": {
											"typeIdentifier": "t_array$_t_bytes32_$6_storage_ptr",
											"typeString": "bytes32[6]"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "249:18:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2221,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "275:0:24"
						},
						"scope": 2287,
						"src": "230:91:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2262,
							"nodeType": "Block",
							"src": "356:151:24",
							"statements": [
								{
									"expression": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"commonType": {
													"typeIdentifier": "t_address",
													"typeString": "address"
												},
												"id": 2241,
												"isConstant": false,
												"isLValue": false,
												"isPure": false,
												"lValueRequested": false,
												"leftExpression": {
													"argumentTypes": null,
													"id": 2238,
													"name": "owner",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2202,
													"src": "370:5:24",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"nodeType": "BinaryOperation",
												"operator": "==",
												"rightExpression": {
													"argumentTypes": null,
													"expression": {
														"argumentTypes": null,
														"id": 2239,
														"name": "msg",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2937,
														"src": "379:3:24",
														"typeDescriptions": {
															"typeIdentifier": "t_magic_message",
															"typeString": "msg"
														}
													},
													"id": 2240,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"memberName": "sender",
													"nodeType": "MemberAccess",
													"referencedDeclaration": null,
													"src": "379:10:24",
													"typeDescriptions": {
														"typeIdentifier": "t_address",
														"typeString": "address"
													}
												},
												"src": "370:19:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_bool",
													"typeString": "bool"
												}
											],
											"id": 2237,
											"name": "require",
											"nodeType": "Identifier",
											"overloadedDeclarations": [
												2940,
												2941
											],
											"referencedDeclaration": 2940,
											"src": "362:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_function_require_pure$_t_bool_$returns$__$",
												"typeString": "function (bool) pure"
											}
										},
										"id": 2242,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "functionCall",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "362:28:24",
										"typeDescriptions": {
											"typeIdentifier": "t_tuple$__$",
											"typeString": "tuple()"
										}
									},
									"id": 2243,
									"nodeType": "ExpressionStatement",
									"src": "362:28:24"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										},
										"id": 2250,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"arguments": [
												{
													"argumentTypes": null,
													"id": 2245,
													"name": "_name",
													"nodeType": "Identifier",
													"overloadedDeclarations": [],
													"referencedDeclaration": 2234,
													"src": "417:5:24",
													"typeDescriptions": {
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												}
											],
											"expression": {
												"argumentTypes": [
													{
														"typeIdentifier": "t_string_memory_ptr",
														"typeString": "string memory"
													}
												],
												"id": 2244,
												"name": "stringToBytes32",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2286,
												"src": "401:15:24",
												"typeDescriptions": {
													"typeIdentifier": "t_function_internal_nonpayable$_t_string_memory_ptr_$returns$_t_bytes32_$",
													"typeString": "function (string memory) returns (bytes32)"
												}
											},
											"id": 2246,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"kind": "functionCall",
											"lValueRequested": false,
											"names": [],
											"nodeType": "FunctionCall",
											"src": "401:22:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"baseExpression": {
												"argumentTypes": null,
												"id": 2247,
												"name": "name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2215,
												"src": "427:4:24",
												"typeDescriptions": {
													"typeIdentifier": "t_array$_t_bytes32_$6_storage",
													"typeString": "bytes32[6] storage ref"
												}
											},
											"id": 2249,
											"indexExpression": {
												"argumentTypes": null,
												"hexValue": "32",
												"id": 2248,
												"isConstant": false,
												"isLValue": false,
												"isPure": true,
												"kind": "number",
												"lValueRequested": false,
												"nodeType": "Literal",
												"src": "432:1:24",
												"subdenomination": null,
												"typeDescriptions": {
													"typeIdentifier": "t_rational_2_by_1",
													"typeString": "int_const 2"
												},
												"value": "2"
											},
											"isConstant": false,
											"isLValue": true,
											"isPure": false,
											"lValueRequested": false,
											"nodeType": "IndexAccess",
											"src": "427:7:24",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes32",
												"typeString": "bytes32"
											}
										},
										"src": "401:33:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": {
										"id": 2260,
										"nodeType": "Block",
										"src": "472:31:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2258,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2256,
														"name": "combined",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2205,
														"src": "480:8:24",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "66616c7365",
														"id": 2257,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "491:5:24",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "false"
													},
													"src": "480:16:24",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2259,
												"nodeType": "ExpressionStatement",
												"src": "480:16:24"
											}
										]
									},
									"id": 2261,
									"nodeType": "IfStatement",
									"src": "397:106:24",
									"trueBody": {
										"id": 2255,
										"nodeType": "Block",
										"src": "436:30:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"id": 2253,
													"isConstant": false,
													"isLValue": false,
													"isPure": false,
													"lValueRequested": false,
													"leftHandSide": {
														"argumentTypes": null,
														"id": 2251,
														"name": "combined",
														"nodeType": "Identifier",
														"overloadedDeclarations": [],
														"referencedDeclaration": 2205,
														"src": "444:8:24",
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														}
													},
													"nodeType": "Assignment",
													"operator": "=",
													"rightHandSide": {
														"argumentTypes": null,
														"hexValue": "74727565",
														"id": 2252,
														"isConstant": false,
														"isLValue": false,
														"isPure": true,
														"kind": "bool",
														"lValueRequested": false,
														"nodeType": "Literal",
														"src": "455:4:24",
														"subdenomination": null,
														"typeDescriptions": {
															"typeIdentifier": "t_bool",
															"typeString": "bool"
														},
														"value": "true"
													},
													"src": "444:15:24",
													"typeDescriptions": {
														"typeIdentifier": "t_bool",
														"typeString": "bool"
													}
												},
												"id": 2254,
												"nodeType": "ExpressionStatement",
												"src": "444:15:24"
											}
										]
									}
								}
							]
						},
						"documentation": null,
						"id": 2263,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "combine",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2235,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2234,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2263,
									"src": "342:12:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2233,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "342:6:24",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "341:14:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2236,
							"nodeType": "ParameterList",
							"parameters": [],
							"src": "356:0:24"
						},
						"scope": 2287,
						"src": "325:182:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					},
					{
						"body": {
							"id": 2285,
							"nodeType": "Block",
							"src": "580:152:24",
							"statements": [
								{
									"assignments": [
										2271
									],
									"declarations": [
										{
											"constant": false,
											"id": 2271,
											"name": "tmp",
											"nodeType": "VariableDeclaration",
											"scope": 2286,
											"src": "586:16:24",
											"stateVariable": false,
											"storageLocation": "memory",
											"typeDescriptions": {
												"typeIdentifier": "t_bytes_memory_ptr",
												"typeString": "bytes"
											},
											"typeName": {
												"id": 2270,
												"name": "bytes",
												"nodeType": "ElementaryTypeName",
												"src": "586:5:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_storage_ptr",
													"typeString": "bytes"
												}
											},
											"value": null,
											"visibility": "internal"
										}
									],
									"id": 2275,
									"initialValue": {
										"argumentTypes": null,
										"arguments": [
											{
												"argumentTypes": null,
												"id": 2273,
												"name": "_name",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2265,
												"src": "611:5:24",
												"typeDescriptions": {
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											}
										],
										"expression": {
											"argumentTypes": [
												{
													"typeIdentifier": "t_string_memory_ptr",
													"typeString": "string memory"
												}
											],
											"id": 2272,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"lValueRequested": false,
											"nodeType": "ElementaryTypeNameExpression",
											"src": "605:5:24",
											"typeDescriptions": {
												"typeIdentifier": "t_type$_t_bytes_storage_ptr_$",
												"typeString": "type(bytes storage pointer)"
											},
											"typeName": "bytes"
										},
										"id": 2274,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"kind": "typeConversion",
										"lValueRequested": false,
										"names": [],
										"nodeType": "FunctionCall",
										"src": "605:12:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes_memory",
											"typeString": "bytes memory"
										}
									},
									"nodeType": "VariableDeclarationStatement",
									"src": "586:31:24"
								},
								{
									"condition": {
										"argumentTypes": null,
										"commonType": {
											"typeIdentifier": "t_uint256",
											"typeString": "uint256"
										},
										"id": 2279,
										"isConstant": false,
										"isLValue": false,
										"isPure": false,
										"lValueRequested": false,
										"leftExpression": {
											"argumentTypes": null,
											"expression": {
												"argumentTypes": null,
												"id": 2276,
												"name": "tmp",
												"nodeType": "Identifier",
												"overloadedDeclarations": [],
												"referencedDeclaration": 2271,
												"src": "628:3:24",
												"typeDescriptions": {
													"typeIdentifier": "t_bytes_memory_ptr",
													"typeString": "bytes memory"
												}
											},
											"id": 2277,
											"isConstant": false,
											"isLValue": false,
											"isPure": false,
											"lValueRequested": false,
											"memberName": "length",
											"nodeType": "MemberAccess",
											"referencedDeclaration": null,
											"src": "628:10:24",
											"typeDescriptions": {
												"typeIdentifier": "t_uint256",
												"typeString": "uint256"
											}
										},
										"nodeType": "BinaryOperation",
										"operator": "==",
										"rightExpression": {
											"argumentTypes": null,
											"hexValue": "30",
											"id": 2278,
											"isConstant": false,
											"isLValue": false,
											"isPure": true,
											"kind": "number",
											"lValueRequested": false,
											"nodeType": "Literal",
											"src": "642:1:24",
											"subdenomination": null,
											"typeDescriptions": {
												"typeIdentifier": "t_rational_0_by_1",
												"typeString": "int_const 0"
											},
											"value": "0"
										},
										"src": "628:15:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bool",
											"typeString": "bool"
										}
									},
									"falseBody": null,
									"id": 2283,
									"nodeType": "IfStatement",
									"src": "624:46:24",
									"trueBody": {
										"id": 2282,
										"nodeType": "Block",
										"src": "645:25:24",
										"statements": [
											{
												"expression": {
													"argumentTypes": null,
													"hexValue": "307830",
													"id": 2280,
													"isConstant": false,
													"isLValue": false,
													"isPure": true,
													"kind": "number",
													"lValueRequested": false,
													"nodeType": "Literal",
													"src": "660:3:24",
													"subdenomination": null,
													"typeDescriptions": {
														"typeIdentifier": "t_rational_0_by_1",
														"typeString": "int_const 0"
													},
													"value": "0x0"
												},
												"functionReturnParameters": 2269,
												"id": 2281,
												"nodeType": "Return",
												"src": "653:10:24"
											}
										]
									}
								},
								{
									"externalReferences": [
										{
											"name": {
												"declaration": 2268,
												"isOffset": false,
												"isSlot": false,
												"src": "693:4:24",
												"valueSize": 1
											}
										},
										{
											"_name": {
												"declaration": 2265,
												"isOffset": false,
												"isSlot": false,
												"src": "711:5:24",
												"valueSize": 1
											}
										}
									],
									"id": 2284,
									"nodeType": "InlineAssembly",
									"operations": "{\n    name := mload(add(_name, 32))\n}",
									"src": "676:56:24"
								}
							]
						},
						"documentation": null,
						"id": 2286,
						"implemented": true,
						"isConstructor": false,
						"isDeclaredConst": false,
						"modifiers": [],
						"name": "stringToBytes32",
						"nodeType": "FunctionDefinition",
						"parameters": {
							"id": 2266,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2265,
									"name": "_name",
									"nodeType": "VariableDeclaration",
									"scope": 2286,
									"src": "536:19:24",
									"stateVariable": false,
									"storageLocation": "memory",
									"typeDescriptions": {
										"typeIdentifier": "t_string_memory_ptr",
										"typeString": "string"
									},
									"typeName": {
										"id": 2264,
										"name": "string",
										"nodeType": "ElementaryTypeName",
										"src": "536:6:24",
										"typeDescriptions": {
											"typeIdentifier": "t_string_storage_ptr",
											"typeString": "string"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "535:21:24"
						},
						"payable": false,
						"returnParameters": {
							"id": 2269,
							"nodeType": "ParameterList",
							"parameters": [
								{
									"constant": false,
									"id": 2268,
									"name": "name",
									"nodeType": "VariableDeclaration",
									"scope": 2286,
									"src": "566:12:24",
									"stateVariable": false,
									"storageLocation": "default",
									"typeDescriptions": {
										"typeIdentifier": "t_bytes32",
										"typeString": "bytes32"
									},
									"typeName": {
										"id": 2267,
										"name": "bytes32",
										"nodeType": "ElementaryTypeName",
										"src": "566:7:24",
										"typeDescriptions": {
											"typeIdentifier": "t_bytes32",
											"typeString": "bytes32"
										}
									},
									"value": null,
									"visibility": "internal"
								}
							],
							"src": "565:14:24"
						},
						"scope": 2287,
						"src": "511:221:24",
						"stateMutability": "nonpayable",
						"superFunction": null,
						"visibility": "public"
					}
				],
				"scope": 2288,
				"src": "26:708:24"
			}
		],
		"src": "0:735:24"
	},
	"compiler": {
		"name": "solc",
		"version": "0.4.24+commit.e67f0147.Emscripten.clang"
	},
	"networks": {},
	"schemaVersion": "2.0.1",
	"updatedAt": "2020-10-22T15:28:26.809Z"
};


//////////////////
// WEBPACK FOOTER
// ./build/contracts/University.json
// module id = 1053
// module chunks = 0